import gql from 'graphql-tag';
const TAB_YOURE_IT_ACTIVITY_FRAGMENT = gql `
  fragment TabYoureItActivityFragment on TabYoureItActivity {
    rounds {
      roundIndex
      sounds
      images
      blocks {
        steps {
          stepIndex
          answer
          imagePath
          blockIndex
          containerIndex
        }
      }
      steps {
        stepIndex
        answer
        imagePath
        blockIndex
        containerIndex
      }
    }
  }
`;
export default TAB_YOURE_IT_ACTIVITY_FRAGMENT;
